var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstAidKit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359 4704 c-108 -33 -204 -131 -239 -243 -18 -58 -20 -92 -20 -402 l0 -339 -297 0 c-231 0 -312 -4 -362 -15 -211 -50 -382 -224 -427 -434 -20 -98 -20 -2324 0 -2422 23 -105 72 -194 151 -275 84 -85 156 -127 261 -154 76 -20 115 -20 2134 -20 2016 0 2058 0 2134 20 108 27 169 63 256 150 85 85 133 170 156 279 20 98 20 2324 0 2422 -45 209 -217 384 -427 434 -50 11 -131 15 -361 15 l-298 0 0 339 c0 310 -2 344 -20 402 -36 116 -130 210 -243 244 -74 22 -2327 21 -2398 -1z m2231 -699 l0 -285 -1030 0 -1030 0 0 285 0 285 1030 0 1030 0 0 -285z m-710 -1245 l0 -380 380 0 380 0 0 -320 0 -320 -380 0 -380 0 0 -380 0 -380 -320 0 -320 0 0 380 0 380 -380 0 -380 0 0 320 0 320 380 0 380 0 0 380 0 380 320 0 320 0 0 -380z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstAidKit);
export default __webpack_public_path__ + "static/media/firstAidKit.bba037d1f843e66f3020aa049d7620a9.svg";
export { ForwardRef as ReactComponent };